export const API_ERRORS = 'API_ERRORS';
export const CLEAR_ERRORS = 'CLEAR_ERRORS';
export const SUCCESS_MESSAGE = 'SUCCESS_MESSAGE';
export const WARNING_MESSAGE = 'WARNING_MESSAGE';
export const INFO_MESSAGE = 'INFO_MESSAGE';
export const CLEAR_ERRORS_SET_MODAL = 'CLEAR_ERRORS_SET_MODAL';

export const LOGOUT_USER = 'LOGOUT_USER';
export const START_IDLE_TIMER = 'START_IDLE_TIMER';
export const SHOW_IDLETIME_POPUP = 'SHOW_IDLETIME_POPUP';
export const START_LOGOUT = 'START_LOGOUT';
export const RESET_IDLE_TIMER = 'RESET_IDLE_TIMER';

export const CLIENT_VALIDATION_ERROR = 'CLIENT_VALIDATION_ERROR';
export const HIDE_LOADING_INDICATOR = 'HIDE_LOADING_INDICATOR';
export const SHOW_LOADING_INDICATOR = 'SHOW_LOADING_INDICATOR';
export const GET_ENGAGEMENT = 'GET_ENGAGEMENT';
export const GET_CLIENT_ENGAGEMENTS = 'GET_CLIENT_ENGAGEMENTS';
export const CLEAR_CLIENT_ENGAGEMENTS = 'CLEAR_CLIENT_ENGAGEMENTS';
export const GET_ALL_USER_ENGAGEMENTS = 'GET_ALL_USER_ENGAGEMENTS';
export const LOAD_ENGAGEMENTMETADATA = 'LOAD_ENGAGEMENTMETADATA';
export const GET_ENGAGEMENT_USERS_WITHROLES = 'GET_ENGAGEMENT_USERS_WITHROLES';
export const GET_QUICKLINKS_BY_ENGAGEMENTID = 'GET_QUICKLINKS_BY_ENGAGEMENTID';
export const GET_CONFIGURATIONS = 'GET_CONFIGURATIONS';
export const GET_COUNTRY_STATUS = 'GET_COUNTRY_STATUS';
export const GET_ALL_ENGAGEMENT_USER_ROLES = 'GET_ALL_ENGAGEMENT_USER_ROLES';
export const GET_ALL_RBAC_USER_ROLES = 'GET_ALL_RBAC_USER_ROLES';
export const GET_WORKSPACE_METADATA = 'GET_WORKSPACE_METADATA';
export const CHECK_USER_ACCEPTED_PAANS_POLICY = 'CHECK_USER_ACCEPTED_PAANS_POLICY';
export const GET_USER_PREFERENCES = 'GET_USER_PREFERENCES';
export const SET_USER_PREFERENCES = 'SET_USER_PREFERENCES';
export const CREATE_USER_PREFERENCES = 'CREATE_USER_PREFERENCES';
export const GET_TIMEZONES = 'GET_TIMEZONES';
export const GET_ALL_CLIENTS = 'GET_ALL_CLIENTS';
export const CREATE_PROJECT = 'CREATE_PROJECT';
export const DRAFT_PROJECT = 'DRAFT_PROJECT';
export const CANCEL_PROJECT = 'CANCEL_PROJECT';
export const UPDATE_PROJECT = 'UPDATE_PROJECT';
export const CLEAR_ALL_PROJECTS = 'CLEAR_ALL_PROJECTS';
export const CLEAR_PROJECT = 'CLEAR_PROJECT';
export const GET_SAMPLE = 'GET_SAMPLE';

export const GET_ALL_PROJECTS = 'GET_ALL_PROJECTS';
export const GET_ALL_OTHER_PROJECTS = 'GET_ALL_OTHER_PROJECTS';
export const GET_PROJECT_ENTITIES = 'GET_PROJECT_ENTITIES';
export const GET_PROJECT_DETAILS = 'GET_PROJECT_DETAILS';
export const CLEAN_PROJECT_DETAILS = 'CLEAN_PROJECT_DETAILS';
export const MARK_COMPLETE_PROJECT = 'MARK_COMPLETE_PROJECT';
export const REMOVE_PROJECT = 'REMOVE_PROJECT';
export const DELETE_PROJECT = 'DELETE_PROJECT';
export const UPDATE_PROJECT_STATUS = 'UPDATE_PROJECT_STATUS';
export const UPDATE_PROJECT_CUSTOM_COLUMNS = 'UPDATE_PROJECT_CUSTOM_COLUMNS';

export const GET_ORG_CHART = 'GET_ORG_CHART';
export const SET_ORG_CHART = 'SET_ORG_CHART';

export const GET_QUICK_FILTERS = 'GET_QUICK_FILTERS';
export const ADD_QUICK_FILTERS = 'ADD_QUICK_FILTERS';
export const EDIT_QUICK_FILTERS = 'EDIT_QUICK_FILTERS';
export const DELETE_QUICK_FILTERS = 'DELETE_QUICK_FILTERS';
export const RESET_NEW_FLAG = 'RESET_NEW_FLAG';

/*user search*/
export const GET_USER_SEARCH = 'GET_USER_SEARCH';
export const CLEAR_USER = 'CLEAR_USER';

//Dashboard
export const GET_ENGAGEMENT_METRICS = 'GET_ENGAGEMENT_METRICS';
export const CLEAN_ENGAGEMENT_METRICS = 'CLEAN_ENGAGEMENT_METRICS';

export const UPDATE_DISPLAY_DATA = 'UPDATE_DISPLAY_DATA';
export const UPDATE_TREE_ORG = 'UPDATE_TREE_ORG';

export const UPDATE_FILTER_DASHBOARD_TILES = 'UPDATE_FILTER_DASHBOARD_TILES';
export const CLEAR_FILTER_DASHBOARD_TILES = 'CLEAR_FILTER_DASHBOARD_TILES';

// Delegate
export const CREATE_DELEGATE = 'CREATE_DELEGATE';

//Delete Delegates
export const DELETE_DELEGATE = 'DELETE_DELEGATE';

//set Delegates active tab
export const SET_DELEGATE_ACTIVE_TAB = 'SET_DELEGATE_ACTIVE_TAB';

// AccessGroups
export const ADD_GROUP = 'ADD_GROUP';
export const GET_PROJECT_GROUPS = 'GET_PROJECT_GROUPS';
export const SET_IS_MODAL_OPEN = 'SET_IS_MODAL_OPEN';
export const DELETE_GROUP = 'DELETE_GROUP';
export const UPDATE_GROUP = 'UPDATE_GROUP';
export const CLEAR_ALL_GROUPS = 'CLEAR_ALL_GROUPS';

// EngagementUser
export const GET_ENGAGEMENT_USER = 'GET_ENGAGEMENT_USER';

// Edit project
export const GET_PROJECT_TO_EDIT = 'GET_PROJECT_TO_EDIT';
export const SET_EDIT_MODE = 'SET_EDIT_MODE';
export const GET_ALL_GROUPS = 'GET_ALL_GROUPS';
export const EDIT_GROUP_LOCAL = 'EDIT_GROUP_LOCAL';
export const DELETE_GROUP_LOCAL = 'DELETE_GROUP_LOCAL';

// Roll forward project
export const COPY_GROUP = 'COPY_GROUP';
export const GET_PROJECT_TO_ROLL_FORWARD = 'GET_PROJECT_TO_ROLL_FORWARD';
export const CREATE_ROLL_FORWARD_PROJECT = 'CREATE_ROLL_FORWARD_PROJECT';
export const GET_ALL_CLIENTS_ROLL_FORWARD = 'GET_ALL_CLIENTS_ROLL_FORWARD';
export const SET_ROLL_FORWAD_MODE = 'SET_ROLL_FORWAD_MODE';
export const FINISH_PROJECT = 'FINISH_PROJECT';

export const ADD_MEMBER = 'ADD_MEMBER';
export const UPDATE_MEMBER = 'UPDATE_MEMBER';
export const DELETE_MEMBER = 'DELETE_MEMBER';
export const SET_EDIT_ACCESSGROUP = 'SET_EDIT_ACCESSGROUP';
export const SET_MULTI_SELECT = 'SET_MULTI_SELECT';
export const SET_OVERSIGHT_ACTIVE_TAB = 'SET_OVERSIGHT_ACTIVE_TAB';

export const GET_PERMISSIONS = 'GET_PERMISSIONS';

export const GET_ENGAGEMENT_CONTACT_DETAILS = 'GET_ENGAGEMENT_CONTACT_DETAILS';
export const CLEAR_ENGAGEMENT_CONTAC_DETAILS = 'CLEAR_ENGAGEMENT_CONTAC_DETAILS';

//Admin User
export const GET_ADMIN_USER = 'GET_ADMIN_USER';
export const CLEAR_ADMIN_USER = 'CLEAR_ADMIN_USER';
export const GET_ADMIN_USER_PROJECT = 'GET_ADMIN_USER_PROJECT';
export const CLEAR_ADMIN_USER_PROJECT = 'CLEAR_ADMIN_USER_PROJECT';
export const GET_ADMIN_USER_CLIENT = 'GET_ADMIN_USER_CLIENT';
export const CLEAR_ADMIN_USER_CLIENT = 'CLEAR_ADMIN_USER_CLIENT';
export const GET_ADMIN_USER_OTHER_PROJECT = 'GET_ADMIN_USER_OTHER_PROJECT';
export const CLEAR_ADMIN_USER_OTHER_PROJECT = 'CLEAR_ADMIN_USER_OTHER_PROJECT';
export const SET_ADMIN_USER_ACTIVE_TAB = 'SET_ADMIN_USER_ACTIVE_TAB';
export const GET_ADMIN_USERS = 'GET_ADMIN_USERS';
export const CLEAR_ADMIN_USERS = 'CLEAR_ADMIN_USERS';
export const CREATE_ADMIN_USER = 'CREATE_ADMIN_USER';
export const SET_IS_UNSAVED_USER_DATA = 'SET_IS_UNSAVED_USER_DATA';
export const SET_UNSAVED_DATA = 'SET_UNSAVED_DATA';
export const CLEAR_UNSAVED_DATA_STATE = 'CLEAR_UNSAVED_DATA_STATE';
export const SET_USER_THEME = 'SET_USER_THEME';

// ContactDB
export const GET_CONTACTS = 'GET_CONTACTS';
export const GET_FILTER_ENTITIES = 'GET_FILTER_ENTITIES';
export const SET_USER_COLUMNS = 'SET_USER_TABLE';
export const SET_CONTACTSDB_FILTER = 'SET_CONTACTSDB_FILTER';
export const GET_USER_COLUMNS = 'GET_USER_COLUMNS';
export const FILTER_CONTACTS = 'FILTER_CONTACTS';
export const SELECT_CONTACT = 'SELECT_CONTACT';
export const RESET_BULK_SELECTION = 'RESET_BULK_SELECTION';
export const CLEAR_CONTACTSDB_FILTER = 'CLEAR_CONTACTSDB_FILTER';
export const SET_CONTACT_SELECTED = 'SET_CONTACT_SELECTED';
export const GET_COUNTRIES = 'GET_COUNTRIES';
export const GET_MESSAGE_LOG = 'GET_MESSAGE_LOG';
export const GET_FILTER_MESSAGE_LOG = 'GET_FILTER_MESSAGE_LOG';
export const SET_MESSAGE_LOG = 'SET_MESSAGE_LOG';
export const SET_MESSAGE_LOG_FILTER = 'SET_MESSAGE_LOG_FILTER';
export const CLEAR_MESSAGE_LOG_FILTER = 'CLEAR_MESSAGE_LOG_FILTER';
export const SET_TAGS = 'SET_TAGS';
export const SET_CUSTOM_TAGS = 'SET_CUSTOM_TAGS';
export const DELETE_CONTACTS = 'DELETE_CONTACTS';
export const ADD_CONTACTS_PROJECT_ENTITY = 'ADD_CONTACTS_PROJECT_ENTITY';
export const GET_USER_MS_DATA = 'GET_USER_MS_DATA';
export const CLEAN_USER_MS_DATA = 'CLEAN_USER_MS_DATA';
export const UPDATE_CONTACTS_CUSTOM_COL_ATTRIBUTE = 'UPDATE_CONTACTS_CUSTOM_COL_ATTRIBUTE';
export const UPDATE_ENTITY = 'UPDATE_ENTITY';

// ContactDB AccessLog
export const GET_POTENTIAL_CONTACTS_TO_ADD = 'GET_POTENTIAL_CONTACTS_TO_ADD';
export const GET_POTENTIAL_CONTACTS_TO_REMOVE = 'GET_POTENTIAL_CONTACTS_TO_REMOVE';
export const IGNORE_POTENTIAL_CONTACT_TO_ADD = 'IGNORE_POTENTIAL_CONTACT_TO_ADD';
export const ADD_POTENTIAL_CONTACT = 'ADD_POTENTIAL_CONTACT';
export const IGNORE_POTENTIAL_CONTACT_TO_REMOVE = 'IGNORE_POTENTIAL_CONTACT_TO_REMOVE';
export const REMOVE_POTENTIAL_CONTACT = 'REMOVE_POTENTIAL_CONTACT';
export const IGNORE_ALL_POTENTIAL_CONTACTS_TO_ADD = 'IGNORE_ALL_POTENTIAL_CONTACTS_TO_ADD';
export const ADD_ALL_POTENTIAL_CONTACTS_TO_ADD = 'ADD_ALL_POTENTIAL_CONTACTS_TO_ADD';
export const IGNORE_ALL_POTENTIAL_CONTACTS_TO_REMOVE = 'IGNORE_ALL_POTENTIAL_CONTACTS_TO_REMOVE';

// ContactDB ManageAccess
export const UPDATE_CONTACTS_ACCESS = 'UPDATE_CONTACTS_ACCESS';

// Key Contact
export const GET_ENTITY_ADMIN_KEY_CONTACTS = 'GET_ENTITY_ADMIN_KEY_CONTACTS';
export const GET_ENTITY_ADMINS_DETAILS = 'GET_ENTITY_ADMINS_DETAILS';

// Activity Log
export const GET_ACTIVITY_LOG = 'GET_ACTIVITY_LOG';
export const GET_ACTIVITY_LOG_EXPORT_DATA = 'GET_ACTIVITY_LOG_EXPORT_DATA';

// Reconciliations
export const GET_ALL_RECONCILIATIONS = 'GET_ALL_RECONCILIATIONS';
export const CLEAR_SELECTED_RECONCILIATION = 'CLEAR_SELECTED_RECONCILIATION';
export const GET_RECONCILIATION_ACCOUNTS = 'GET_RECONCILIATION_ACCOUNTS';
export const GET_RECONCILIATION_RISKS = 'GET_RECONCILIATION_RISKS';
export const UPDATE_RECONCILIATION_ACCOUNT = 'UPDATE_RECONCILIATION_ACCOUNT';
export const UPDATE_RECONCILIATION_RISK = 'UPDATE_RECONCILIATION_RISK';
export const UPDATE_GROUP_COMPONENT_ACCOUNT = 'UPDATE_GROUP_COMPONENT_ACCOUNT';
export const UPDATE_GROUP_COMPONENT_RISK = 'UPDATE_GROUP_COMPONENT_RISK';

// Client Portal Metrics
export const GET_CLIENT_REQUEST = 'GET_CLIENT_REQUEST';

//GRA
export const GET_RISKS = 'GET_RISKS';
